import React from 'react';

export const CalmStat = ({ label, current, max, color, bodyFont, c }) => {
  const pct = max > 0 ? Math.max(0, Math.min(1, current / max)) : 0;
  return (
    <div>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        fontFamily: bodyFont,
        fontSize: '0.72rem',
        marginBottom: 4,
      }}>
        <span style={{ color: c.textMuted, letterSpacing: '0.04em' }}>{label}</span>
        <span style={{ color, fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
          {current}<span style={{ color: c.textMuted, fontWeight: 400 }}> / {max}</span>
        </span>
      </div>
      <div style={{
        height: 4,
        background: 'rgba(255,255,255,0.06)',
        borderRadius: 2,
        overflow: 'hidden',
      }}>
        <div style={{
          width: `${pct * 100}%`,
          height: '100%',
          background: color,
          borderRadius: 2,
          transition: 'width 220ms ease',
        }} />
      </div>
    </div>
  );
};
